<template>
  <scroll-bar>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#1f2937"
      text-color="#c7d2e0"
      active-text-color="#f4b740"
    >
      <sidebar-item
        :routes="routes"
        :payment-apply-pending-count="paymentApplyPendingCount"
        :ap-pending-count="apPendingCount"
        :hold-cancellation-today-count="holdCancellationTodayCount"
      />
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'
import {
  hasHoldOrderSidebarBadgeMenu,
  refreshHoldSidebarBadge
} from '@/utils/holdSidebarBadge'

/** 当前账号侧栏是否展示「财务管理 → 付款申请 / 应付款管理」任一菜单项（具备时才轮询财务角标） */
function hasFinSidebarBadgeMenu(routers) {
  const list = routers || []
  const fin = list.find(r => r.name === 'fin')
  if (!fin || !fin.children || !fin.children.length) return false
  return fin.children.some(c => !c.hidden && (c.name === 'apply' || c.name === 'ap'))
}

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers',
      'paymentApplyPendingCount',
      'apPendingCount',
      'holdCancellationTodayCount',
      'hasFinResource',
      'hasOrderResource'
    ]),
    routes() {
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    /** 菜单与 resourceUrls 同时具备时才轮询角标（避免仅有菜单、未分配 /fin/** 时 403） */
    canPollFinSidebarBadges() {
      return hasFinSidebarBadgeMenu(this.routers) && this.hasFinResource
    },
    canPollHoldOrderSidebarBadge() {
      return hasHoldOrderSidebarBadgeMenu(this.routers) && this.hasOrderResource
    }
  },
  watch: {
    routers: {
      handler() {
        this.syncFinSidebarBadgePoll()
        this.syncHoldOrderSidebarBadgePoll()
      },
      deep: true
    },
    hasFinResource() {
      this.syncFinSidebarBadgePoll()
    },
    hasOrderResource() {
      this.syncHoldOrderSidebarBadgePoll()
    },
    canPollFinSidebarBadges(v) {
      if (!v) {
        this.$store.commit('SET_PAYMENT_APPLY_PENDING_COUNT', 0)
        this.$store.commit('SET_AP_PENDING_COUNT', 0)
      }
    },
    canPollHoldOrderSidebarBadge(v) {
      if (!v) {
        this.$store.commit('SET_HOLD_CANCELLATION_TODAY_COUNT', 0)
      }
    },
    '$route.path'() {
      this.refreshHoldSidebarBadgeNow()
    }
  },
  created() {
    this.syncFinSidebarBadgePoll()
    this.syncHoldOrderSidebarBadgePoll()
    this._onHoldBadgeVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        this.refreshHoldSidebarBadgeNow()
      }
    }
    document.addEventListener('visibilitychange', this._onHoldBadgeVisibilityChange)
  },
  beforeDestroy() {
    this.clearFinSidebarBadgePoll()
    this.clearHoldOrderSidebarBadgePoll()
    if (this._onHoldBadgeVisibilityChange) {
      document.removeEventListener('visibilitychange', this._onHoldBadgeVisibilityChange)
      this._onHoldBadgeVisibilityChange = null
    }
  },
  methods: {
    refreshHoldSidebarBadgeNow() {
      if (!this.canPollHoldOrderSidebarBadge) return
      refreshHoldSidebarBadge()
    },
    clearFinSidebarBadgePoll() {
      if (this._finBadgePoll) {
        clearInterval(this._finBadgePoll)
        this._finBadgePoll = null
      }
    },
    clearHoldOrderSidebarBadgePoll() {
      if (this._holdBadgePoll) {
        clearInterval(this._holdBadgePoll)
        this._holdBadgePoll = null
      }
    },
    syncFinSidebarBadgePoll() {
      this.clearFinSidebarBadgePoll()
      if (!this.canPollFinSidebarBadges) {
        return
      }
      this.$store.dispatch('FetchPaymentApplyPendingCount')
      this.$store.dispatch('FetchApPendingCount')
      this._finBadgePoll = window.setInterval(() => {
        this.$store.dispatch('FetchPaymentApplyPendingCount')
        this.$store.dispatch('FetchApPendingCount')
      }, 60000)
    },
    syncHoldOrderSidebarBadgePoll() {
      this.clearHoldOrderSidebarBadgePoll()
      if (!this.canPollHoldOrderSidebarBadge) {
        return
      }
      refreshHoldSidebarBadge()
      this._holdBadgePoll = window.setInterval(() => {
        refreshHoldSidebarBadge()
      }, 60000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue